<template>
<div >
	<Loader :show="loading"></Loader>

	<b-modal id="carCarRequesPreDeliveryModal" :title="title" hide-footer no-close-on-backdrop no-close-on-esc @close="close">
		
        <b-form-group label="Prioridad" >
			<b-form-select v-model="form.priority" class="mb-3">
      			<b-form-select-option :value="null">Normal</b-form-select-option>
      			<b-form-select-option value="MEDIUM">Media</b-form-select-option>
      			<b-form-select-option value="HIGH" >Alta</b-form-select-option>
      		</b-form-select>
		</b-form-group>
		

        <div class="overflow-hidden mt-4">
            <b-button @click="close()" type="button" class="pull-left" size="sm" variant="light">Cancelar</b-button>
            <button type="submit" class="btn btn-primary pull-right" @click="create()" >Confirmar solicitud</button>
            
        </div>

	</b-modal>


</div>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Loader from '@/components/Loader'

export default {
	name: 'carRequestPreDeliveryModal',
	components:{
		Loader
    },
    props:{
        carId:{
            required: true
        }
	},
	mixins: [mixins],
	data () {
		return {
			title: 'Solicitar pre entrega',
			loading:false,
            form: {
				priority: null,
                cars:[]
			},
		}
    },
    
	methods: {
		open () {
			this.form.cars = []
			this.showModal()
		},
        showModal() {
			this.show = true
			this.$bvModal.show('carCarRequesPreDeliveryModal')
		},
		close () {
			this.show = false
			this.form = {
                priority: null,
                cars:[]
            }
			this.$bvModal.hide('carCarRequesPreDeliveryModal')
        },
		create () {
			if(!this.loading  ) {
				this.loading = true
				let dataInput = {
					cars: [],
					priority: this.form.priority
				}
				dataInput.cars.push(this.carId)

				this.$apollo.mutate({
					mutation: gql`mutation ( $data: RequestPreDeliveryInput! ){
						requestPreDelivery( data: $data) {
							id
						}
					}`,
					variables: {
						data:dataInput
					}
				})
				.then(() => {
					this.$toast.success('Solicitud realizada correctamente')
					this.$emit('changed')
					this.loading = false
					this.close()
				})
				.catch( (error) => {
					this.errors = this.parseGQLErrors(error)
					this.$toast.error('Error!')
					this.loading = false
				})
			}

		},
	}
}


</script>
